<template>
  <!-- <v-card id="print-content" @click="$emit('close')"> -->
  <v-layout
    column
    id="print-content"
    class="print-break-page elevation-2 ml-0 mr-0"
    style="overflow: visible; page-break-after: always; background: white;"
  >
    <print-view-actions
      v-if="printMode"
      :items="csv_data"
      :name="formattedName"
      @printContent="printContent"
      @close="$emit('close')"
    />

    <slot>
      <print-view-formatted-header
        style="max-height: 210px;"
        :section="section"
      />
    </slot>
    <!-- :hide-default-footer="printMode" 
    :rows-per-page-items="printMode ? [-1] : [10, 25, 50, { text: 'All', value: -1 }]"
    -->
    <v-flex>
      <v-data-table
        class="pt-3"
        :headers="complex.headers"
        :items="complex.items"
        :disable-pagination="true"
        :hide-default-footer="true"
        :hideActions="printMode === true"
        :rows-per-page-items="
          pages ? pages : [10, 15, 20, 25, 30, { text: 'All', value: -1 }]
        "
      >
        <template slot="items" slot-scope="props">
          <tr v-if="!props.item._id">
            <td
              align="center"
              :colspan="complex.headers.length"
              style="font-weight: 500; font-size: 1.1em; color: black; background: #f0f0f0;"
            >
              {{ formattedHolderType(props.item.holder_type) }}
            </td>
            <!-- <td :colspan="complex.headers.length" v-for="item in complex.headers.length" :key="item">{{item}}</td> -->
          </tr>
          <tr v-if="props.item._id">
            <td v-if="printMode === false">{{ props.item.first_name }}</td>
            <td v-if="printMode === false">{{ props.item.last_name }}</td>
            <td v-if="printMode === true">
              {{
                [props.item.first_name, props.item.last_name]
                  .filter(obj => {
                    return obj;
                  })
                  .join(" ")
              }}
            </td>
            <td align="center">
              {{ props.item.sign_in_date || props.item.sign_out_date }}
            </td>
            <td align="center">
              {{ props.item.sign_in_time || props.item.sign_out_time }}
            </td>
            <td v-if="contactMode != 'Student'" align="center">
              {{ props.item.mobile || "N/A" }}
            </td>
            <td v-if="hasReason" align="center">
              {{
                props.item.sign_in_reason || props.item.sign_out_reason || "N/A"
              }}
            </td>
            <td
              v-if="hasWWCCStatus && permitted('wwcc')"
              width="60px"
              align="center"
            >
              {{ wwccStatus(props) }}
            </td>
            <td v-if="hasStation" align="center">
              {{
                props.item && props.item.station
                  ? titleCase(props.item.station)
                  : "N/A"
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <report-footer-signature
      style="max-height: 100px;"
      v-if="printMode && needSignatureFooter"
    />
  </v-layout>
</template>

<script>
// import { Printd } from "printd";
import Helpers from "@/mixins/helpers";
import PrintViewActions from "./PrintViewActions";
import ReportFooterSignature from "./ReportFooterSignature";
import PrintViewFormattedHeader from "./PrintViewFormattedHeader";

export default {
  components: {
    PrintViewActions,
    ReportFooterSignature,
    PrintViewFormattedHeader
  },
  props: ["contactMode", "items", "printMode", "pages"],
  mixins: [Helpers],
  data() {
    return {
      formattedName: "",
      csv_data: [],
      complex: {
        selected: [],
        headers: [],
        items: [],
        align: "center"
      },
      itemNames: [],
      section: {
        top: {
          title: "test",
          subtitle: "test subtitle"
        },
        middle: {
          title: "test",
          subtitle: "test subtitle"
        },
        bottom: {
          subtitle: []
        }
      }
    };
  },
  watch: {
    items: {
      handler: function() {
        if (!this.items) {
          return;
        }
        this.populateContent();
        this.processTableHeader();
      }
    }
  },
  computed: {
    needSignatureFooter: function() {
      if (!localStorage.active_user) {
        return false;
      } else {
        let object = JSON.parse(localStorage.active_user);
        return (object.modules || []).includes("sign_footer");
      }
    },
    signMode: function() {
      let state = this.$store.state.filterOptions.sign_mode;
      return state.length === 0
        ? ""
        : state.length === 2
        ? "Sign In/Out"
        : state[0] === "in"
        ? "Sign In"
        : "Sign Out";
    },
    reportGenerateStamp: function() {
      return (
        "Report generated on: " +
        new Date().toLocaleDateString() +
        " at " +
        new Date().toLocaleTimeString()
      );
    },
    printHeaders: function() {
      return [
        {
          text: "Name",
          value: "first_name",
          width: "30%"
        },
        {
          text: "Date",
          value: "sign_in_date" || "sign_out_date",
          width: "120px",
          align: "center",
          sortable: this.printMode === false
        },
        {
          text: "Time",
          value: "sign_in_time" || "sign_out_time",
          width: "120px",
          align: "center",
          sortable: this.printMode === false
        }
      ];
    },
    headers: function() {
      return [
        {
          text: "First Name",
          value: "first_name"
        },
        {
          text: "Last Name",
          value: "last_name"
        },
        {
          text: "Date",
          value: "sign_in_date" || "sign_out_date",
          width: "120px",
          align: "center",
          sortable: this.printMode === false
        },
        {
          text: "Time",
          value: "sign_in_time" || "sign_out_time",
          width: "120px",
          align: "center",
          sortable: this.printMode === false
        }
      ];
    },
    hasReason: function() {
      if (this.contactMode === "Staff") {
        return false;
      }
      return true;
    },
    hasStation: function() {
      // if (this.contactMode === "Staff") {
      //   return false;
      // }
      return true;
    },
    hasWWCCStatus: function() {
      if (this.contactMode === "Student" || this.contactMode === "Staff") {
        return false;
      }
      return true;
    }
  },
  mounted() {
    if (this.items.length > 0) {
      this.populateContent();
    }
    this.processTableHeader();
  },
  methods: {
    formattedHolderType: function(type) {
      type = type === "staff" ? type : type + "s";
      return this.titleCase(type);
    },
    processHeaders: function() {
      var tableHeaders = this.printMode ? this.printHeaders : this.headers;
      let reasonOb = [
        {
          text: "Reason",
          value: "sign_in_reason" || "sign_out_reason",
          align: "center",
          sortable: true
        }
      ];
      let wwccOb = [
        {
          text: "WWCC Status",
          value: "wwcc_card",
          align: "center",
          sortable: false
        }
      ];
      let mobileOb = [
        {
          text: "Mobile",
          value: "mobile",
          align: "center",
          sortable: this.printMode === false
        }
      ];
      let stationOb = [
        {
          text: "Station",
          value: "station",
          align: "center",
          sortable: this.printMode === false
        }
      ];
      if (this.contactMode != "Student") {
        tableHeaders = tableHeaders.concat(mobileOb);
      }
      if (this.hasReason) {
        tableHeaders = tableHeaders.concat(reasonOb);
      }
      if (this.hasWWCCStatus && this.permitted("wwcc")) {
        tableHeaders = tableHeaders.concat(wwccOb);
      }
      if (this.hasStation) {
        tableHeaders = tableHeaders.concat(stationOb);
      }
      this.complex.headers = tableHeaders;

      this.formattedName =
        [
          this.contactMode,
          this.signMode,
          this.$store.state.filterOptions.from_date,
          this.$store.state.filterOptions.to_date
        ]
          .join("_")
          .replace(" ", "")
          .toLowerCase() + ".csv";
    },
    processTableHeader: function() {
      if (this.printMode) {
        let section = JSON.parse(localStorage.printHeader);
        if (section) {
          this.section = section.section;
        }
        return;
      }

      let company = JSON.parse(localStorage.active_user);

      this.section.top.title = company.company_name || company.company.name;
      this.section.top.subtitle = company.email;

      let type = this.contactMode + "s";
      if (this.contactMode === "Staff") {
        type = "Staff";
      }

      let mode = this.signMode;

      this.section.middle.title = "Attendance Sheet - " + type + " " + mode;
      this.section.middle.subtitle =
        mode +
        " details from " +
        this.$store.state.filterOptions.from_date +
        " to " +
        this.$store.state.filterOptions.to_date;

      this.section.bottom.subtitle = [];
      this.section.bottom.subtitle.push(this.reportGenerateStamp);
      this.section.bottom.subtitle.push("Report generated by: edPass");
    },
    populateContent: function() {
      this.processHeaders();

      let items = this.items;
      if (
        this.$route.query &&
        this.$route.query.type === "emergency" &&
        this.$route.query.mode === "all" &&
        items.length > 0
      ) {
        let type = "";
        let formattedList = [];
        for (let index = 0; index < items.length; index++) {
          const element = items[index];
          if (index === 0) {
            formattedList.push({ holder_type: element.holder_type });
            formattedList.push(element);
            type = element.holder_type;
          } else {
            if (type != element.holder_type) {
              formattedList.push({ holder_type: element.holder_type });
            }
            formattedList.push(element);
            type = element.holder_type;
          }
        }
        items = formattedList;
      }

      items = items.map(obj => {
        if (obj.sign_in_date && obj.sign_out_date) {
          obj.completeStatus = "In / Out";
        } else if (obj.sign_in_date) {
          obj.completeStatus = "In";
        } else {
          obj.completeStatus = "Out";
        }
        return obj;
      });

      this.complex.items = items;
      this.processCSVData();
    },
    processCSVData: function() {
      let keys = [
        "key",
        "student",
        "first_name",
        "last_name",
        "mobile",
        "sign_in_reason",
        "sign_out_reason",
        "sign_in_time",
        "sign_out_time",
        "sign_in_date",
        "sign_out_date",
        "wwcc_card",
        "station"
      ];
      this.csv_data = this.complex.items.map(obj => {
        let object = {};
        for (let key of Object.keys(obj)) {
          let k = this.titleCase(key.replace(/_/g, " ")); //;
          if (keys.includes(key)) {
            let status = "No";
            if (key === "student") {
              if (obj["student"] && obj["student"].class) {
                object["Class"] =
                  obj["student"]["class"]["class_type"] || "N/A";
              }
            } else if (key === "wwcc_card") {
              if (obj[key] === 2 || obj[key] === 3) {
                status = "Yes";
              } else if (obj[key] === 1) {
                status = "Yes, Not With Me";
              } else if (obj[key] === 0) {
                status = "No";
              }
              object[k] = status;
            } else {
              object[k] = obj[key];
            }
          }
        }
        return object;
      });
    },
    // populateContent: function() {
    //   this.processHeaders();
    //   this.complex.items = this.items.map(obj => {
    //     if (obj.sign_in_date && obj.sign_out_date) {
    //       obj.completeStatus = "In / Out";
    //     } else if (obj.sign_in_date) {
    //       obj.completeStatus = "In";
    //     } else {
    //       obj.completeStatus = "Out";
    //     }
    //     return obj;
    //   });
    // },
    printContent: function() {
      print();
      /*
      const d = new Printd();
      const styles = [
        "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700%7CMaterial+Icons",
        "https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.0.19/vuetify.min.css",
        "https://unpkg.com/v-data-table/dist/v-data-table.css"
      ];
      d.print(document.getElementById("print-content"), styles);
      */
    },
    wwccStatus: function(object) {
      let status = object.item.wwcc_card;
      switch (status) {
        case 0:
          return "No";
        case 1:
          return "Yes, not with me";
        case 2:
          return "Yes";
        case 3:
          return "Yes";
        default:
          return "N/A";
      }
    }
  }
};
</script>

<style scoped>
.justifybetween {
  display: flex;
  justify-content: space-between;
}
.header {
  text-align: center;
}
.report-info {
  display: flex;
  justify-content: space-between;
}
th {
  text-align: center;
}
@media print {
  body {
    overflow: auto;
    height: auto;
  }
  .scroll-y {
    height: auto;
    overflow: visible;
  }
}
.print-break-page {
  page-break-after: always;
}
</style>
